module.exports = __webpack_public_path__ + "img/omg.50256fb5.svg";